import Link from "next/link";
import React, { memo, useEffect } from "react";
import { li } from "../CommonForm/CommonFormInterface";
import Image from "next/image";

const List = ({
  field,
  extractedListItemData,
  onClickLinkList,
}: {
  field: any;
  extractedListItemData: li[];
  onClickLinkList: (item: li) => void;
}) => {
  return (
    <ul className={field?.className ?? ""} style={{ ...(field.style ?? {}) }}>
      {extractedListItemData?.map((item: li, itemIdx: number) => {
        return (
          <li
            key={`${item?.label ?? "-"}${itemIdx}`}
            style={{ ...(field.itemsStyle ?? {}) }}
            className={item?.localClass}
          >
            {field?.prefix?.image && (
              <Image
                src={
                  (field?.prefix?.baseUrl ||
                    process.env.NEXT_PUBLIC_IMAGE_BASE_URL) +
                  field?.prefix?.image
                }
                alt={field?.imageAlt ?? "Arrow"}
                width={parseFloat(field.imageHeight?.toString() ?? "24")}
                height={parseFloat(field.imageWidth?.toString() ?? "24")}
                style={{
                  height: field.imageHeight,
                  width: field.imageWidth,
                  display: "flex",
                  alignItems: "center",
                }}
                className={`${field?.imageClassName ?? ""}`}
                aria-label={
                  (field?.prefix?.baseUrl ||
                    process.env.NEXT_PUBLIC_IMAGE_BASE_URL) +
                  field?.prefix?.image
                }
                priority={false}
                unoptimized={true}
                fetchPriority="auto"
              />
            )}
            {item?.localLink && (
              <Link
                href={item?.localLink ?? "#"}
                style={{
                  ...(field?.linkStyles ?? {}),
                }}
                className={field.linkClassName}
                target={item?.link?.target}
                onClick={() => onClickLinkList(item)}
                rel={item?.link?.rel}
                prefetch={false}
              >
                {item?.link?.label}
              </Link>
            )}
            {(item?.label
              ? item?.label
              : typeof item === "string"
              ? item
              : "") && (
              <span
                title={
                  item?.label
                    ? item?.label
                    : typeof item === "string"
                    ? item
                    : ""
                }
              >
                {item?.label
                  ? item?.label
                  : typeof item === "string"
                  ? item
                  : ""}
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default memo(List);
